import { ElMessage } from 'element-plus'
import { t } from '@/plugins/i18n'
import { ref, Ref } from 'vue'

export default (
  commit: (v?:any) => void,
  formRef = ref()
): [Ref, (v?:any) => void, () => Promise<unknown>] => {
  const wrap = (v?:any) => {
    const f = formRef.value
    f.validate((valid: boolean) => {
      if (valid) {
        commit(v)
      }
    })
  }
  const valid = (msg = '') =>
    new Promise((resolve) => {
      const f = formRef.value
      f.validate(resolve)
    }).then((res) => {
      if (!res && msg) {
        ElMessage.error(t(msg))
      }
      return res
    })
  return [formRef, wrap, valid]
}
